import thumbnail100StackedArea from './100--stacked-area.png';
import thumbnail100StackedBar from './100--stacked-bar.png';
import thumbnail100StackedColumn from './100--stacked-column.png';
import thumbnailAreaWithNegativeValues from './area-with-negative-values.png';
import thumbnailBarWithLabels from './bar-with-labels.png';
import thumbnailBubbleWithCategories from './bubble-with-categories.png';
import thumbnailBubbleWithNegativeValues from './bubble-with-negative-values.png';
import thumbnailChartCustomisation from './chart-customisation.png';
import thumbnailColumnWithNegativeValues from './column-with-negative-values.png';
import thumbnailCombinationofDifferentSeriesTypes from './combination-of-different-series-types.png';
import thumbnailCustomMarkerShapes from './custom-marker-shapes.png';
import thumbnailCustomTooltips from './custom-tooltips.png';
import thumbnailGroupedBar from './grouped-bar.png';
import thumbnailGroupedColumn from './grouped-column.png';
import thumbnailHistogramWithSpecifiedBins from './histogram-with-specified-bins.png';
import thumbnailLargeDatasets from './large-datasets.png';
import thumbnailLineWithGaps from './line-with-gaps.png';
import thumbnailLogAxis from './log-axis.png';
import thumbnailMarketIndexTreemap from './market-index-treemap.png';
import thumbnailPerMarkerCustomisation from './per-marker-customisation.png';
import thumbnailRealTimeDataUpdates from './real-time-data-updates.png';
import thumbnailSimpleArea from './simple-area.png';
import thumbnailSimpleBar from './simple-bar.png';
import thumbnailSimpleBubble from './simple-bubble.png';
import thumbnailSimpleColumn from './simple-column.png';
import thumbnailSimpleDoughnut from './simple-doughnut.png';
import thumbnailSimpleHistogram from './simple-histogram.png';
import thumbnailSimpleLine from './simple-line.png';
import thumbnailSimplePie from './simple-pie.png';
import thumbnailSimpleScatter from './simple-scatter.png';
import thumbnailStackedArea from './stacked-area.png';
import thumbnailStackedBar from './stacked-bar.png';
import thumbnailStackedColumn from './stacked-column.png';
import thumbnailTimeAxisWithIrregularIntervals from './time-axis-with-irregular-intervals.png';
import thumbnailXYHistogramWithMeanAggregation from './xy-histogram-with-mean-aggregation.png';

const thumbnails = {
    '100--stacked-area': thumbnail100StackedArea,
    '100--stacked-bar': thumbnail100StackedBar,
    '100--stacked-column': thumbnail100StackedColumn,
    'area-with-negative-values': thumbnailAreaWithNegativeValues,
    'bar-with-labels': thumbnailBarWithLabels,
    'bubble-with-categories': thumbnailBubbleWithCategories,
    'bubble-with-negative-values': thumbnailBubbleWithNegativeValues,
    'chart-customisation': thumbnailChartCustomisation,
    'column-with-negative-values': thumbnailColumnWithNegativeValues,
    'combination-of-different-series-types': thumbnailCombinationofDifferentSeriesTypes,
    'custom-marker-shapes': thumbnailCustomMarkerShapes,
    'custom-tooltips': thumbnailCustomTooltips,
    'grouped-bar': thumbnailGroupedBar,
    'grouped-column': thumbnailGroupedColumn,
    'histogram-with-specified-bins': thumbnailHistogramWithSpecifiedBins,
    'large-datasets': thumbnailLargeDatasets,
    'line-with-gaps': thumbnailLineWithGaps,
    'log-axis': thumbnailLogAxis,
    'market-index-treemap': thumbnailMarketIndexTreemap,
    'per-marker-customisation': thumbnailPerMarkerCustomisation,
    'real-time-data-updates': thumbnailRealTimeDataUpdates,
    'simple-area': thumbnailSimpleArea,
    'simple-bar': thumbnailSimpleBar,
    'simple-bubble': thumbnailSimpleBubble,
    'simple-column': thumbnailSimpleColumn,
    'simple-doughnut': thumbnailSimpleDoughnut,
    'simple-histogram': thumbnailSimpleHistogram,
    'simple-line': thumbnailSimpleLine,
    'simple-pie': thumbnailSimplePie,
    'simple-scatter': thumbnailSimpleScatter,
    'stacked-area': thumbnailStackedArea,
    'stacked-bar': thumbnailStackedBar,
    'stacked-column': thumbnailStackedColumn,
    'time-axis-with-irregular-intervals': thumbnailTimeAxisWithIrregularIntervals,
    'xy-histogram-with-mean-aggregation': thumbnailXYHistogramWithMeanAggregation,
}

export default thumbnails;